import { render } from "./SubmitFormForm.vue?vue&type=template&id=2c415736"
import script from "./SubmitFormForm.vue?vue&type=script&lang=js"
export * from "./SubmitFormForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__